import { BaseError } from "@/domains/errors/kinds/BaseError";
import { JsonObject } from "@/domains/common/types";
import { AppErrorCode } from "@/domains/errors/constants";

export class DatabaseNotInitializedError extends BaseError {
  constructor(info?: JsonObject) {
    super({
      code: AppErrorCode.DATABASE,
      message: "Database not initialized. Call init() first.",
      statusCode: 500,
      info,
    });
  }
}

export class DatabaseQueryError extends BaseError {
  constructor(message: string, info?: JsonObject) {
    super({
      code: AppErrorCode.DATABASE,
      message: `Database query failed: ${message}`,
      statusCode: 500,
      info,
    });
  }
}

export class RepositoryError extends BaseError {
  constructor(repositoryName: string, operation: string, originalError?: Error, info?: JsonObject) {
    const message = `${repositoryName} ${operation} failed${
      originalError ? `: ${originalError.message}` : ""
    }`;
    super({
      code: AppErrorCode.DATABASE,
      message,
      statusCode: 500,
      originalError,
      info: {
        ...info,
        ...(originalError && { originalError: originalError.message }),
      },
    });
  }
}

export class DatabaseInitializationError extends BaseError {
  constructor(message: string, info?: JsonObject) {
    super({
      code: AppErrorCode.DATABASE,
      message: `Database initialization failed: ${message}`,
      statusCode: 500,
      info,
    });
  }
}

export class SyncError extends BaseError {
  constructor(message: string, info?: JsonObject) {
    super({
      code: AppErrorCode.DATABASE,
      message: `Sync error: ${message}`,
      statusCode: 500,
      info,
    });
  }
}
